import {InjectionToken, ValueProvider} from "@angular/core";
import {ApiConfig} from "./api-config";

export const APP_CONFIG = new InjectionToken<ApiConfig>('api.config');

export const getAppConfigProvider = (value: ApiConfig): ValueProvider => ({
  provide: APP_CONFIG,
  useValue: value
});
